import React from 'react'
import classes from './Landing.scss'
import Title from './title3.png'
import Jotto from './jotto2.png'
import JottoMobile from './jotto_mobile.png'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import MediaQuery from 'react-responsive'
import LoginBar from '../components/Users/LoginBar'
import Register from '../components/Users/Register'
import Login from '../components/Users/Login'
import { setUsername } from '../actions/users'
import Overlay from '../components/Overlay'
import 'whatwg-fetch'

class Landing extends React.Component {

  constructor(props) {
    super(props)

    const baseUrl = process.env.NODE_ENV === 'production' ? 'https://api.mrjotto.com' : 'http://localhost:3000'
    this.state = { baseUrl, register: false, login: false, selected: '' }
    // load the user
    fetch(`${baseUrl}/user/info`, { credentials: 'include' })
      .then(res => res.json())
      .then(res => {
        if (res.result === 'ok') {
          browserHistory.push('/home')
        }
      })
  }

  renderAppBar(pushUp = false) {
    const appBarClasses = [
      classes.appBar,
      pushUp && classes.push,
    ].join(' ')
    return (
      <div className={appBarClasses}>
        <a target="_blank" href="https://itunes.apple.com/us/app/mr-jotto-classic-word-game/id1373113089?ls=1&mt=8">
          <img className={classes.icon} src="/public/images/apple.jpg" />
        </a>
        <a target="_blank" href="https://play.google.com/store/apps/details?id=com.mrjotto">
          <img className={classes.icon} src="/public/images/android.png" />
        </a>
      </div>
    )
  }

  render() {
    const { baseUrl, register, login } = this.state
    const { setUsername } = this.props

    return (
      <div className={classes.main}>
        <MediaQuery component={() => this.renderAppBar(true)} maxWidth={599} />
        <MediaQuery component={'img'} src={Title} className={classes.fullImage} minWidth={600} />
        <MediaQuery component={'img'} src={Jotto} className={classes.jotto} minWidth={600} />
        <MediaQuery component={'img'} src={JottoMobile} className={classes.jotto} maxWidth={599} />
        <LoginBar baseUrl={baseUrl} className={classes.loginBar} />
        <div className={classes.signupBtns}>
          <span onClick={() => this.setState({ register: true, login: false })}>Sign Up</span>
          <span onClick={() => this.setState({ register: false, login: true })}>Login</span>
        </div>
        {(register || login) && <div className={classes.loginBox}>
          {register && <Register baseUrl={baseUrl} setUsername={setUsername} />}
          {login && <Login baseUrl={baseUrl} setUsername={setUsername} />}
        </div>}
        <MediaQuery component={() => this.renderAppBar(false)} minWidth={600} />
        <Overlay />
      </div>
    )
  }
}

export const mapStateToProps = (state: any, ownProps: any): any => {
  return {
    username: state.username,
  }
}

export const mapDispatchToProps = (dispatch: Function, ownProps: any): any => {
  return {
    setUsername: (username) => dispatch(setUsername(username)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Landing)



/** WEBPACK FOOTER **
 ** ./src/containers/Landing.js
 **/